// Commission Processed Models based on Swagger API

export enum CommissionTransactionType {
  Membership = 'membership',
  Service = 'service',
  Product = 'product',
  Package = 'package'
}

export enum CommissionTransactionMode {
  AutoCalculated = 'auto_calculated',
  Adjustment = 'adjustment',
  Reversal = 'reversal',
  Recalculated = 'recalculated',
  CumulativeAdjustment = 'cumulative_adjustment',
  ComplimentaryAdjustment = 'complimentary_adjustment',
  ComplimentaryReversal = 'complimentary_reversal'
}
// Response from GET /api/CommissionProcessed/tenants/{tenantId}/processed
export interface ProcessedCommissionTransactionDetailResponse {
  id:number;
  date: string;
  type_id: number;
  type_name: CommissionTransactionType;
  plan_id: number;
  plan_name: string | null;
  slab_id: number | null;
  slab_name: string | null;
  amount: number;
  comm_processed_id: number | null;
  notes: string | null;
}

export interface ProcessedCommissionTransactionResponse {
  staff_id: number;
  staff_name: string | null;
  staff_mobile: string | null;
  staff_email_id: string | null;
  type: CommissionTransactionType;
  type_id: number;
  aggregated_amount: number;
  transactions: ProcessedCommissionTransactionDetailResponse[] | null;
}

export interface ProcessedCommissionTransactionResponsePagedResults {
  items: ProcessedCommissionTransactionResponse[] | null;
  statistics: ProcessedCommissionTransactionResponse[] | null;
  total_items: number;
  total_pages: number;
  current_page: number;
}

// Request for POST /api/CommissionProcessed
export interface CreateCommissionProcessedRequest {
  companyId?: number;
  tenantId?: number;
  franchiseId?: number | null;
  staffId?: number;
  notes?: string | null;
  createdByStaffId?: number;
}

// Response from POST /api/CommissionProcessed
export interface CommissionProcessedResponse {
  processedId: number;
  companyId: number;
  tenantId: number;
  franchiseId: number | null;
  staffId: number;
  notes: string | null;
  createdDate: string;
  createdByStaffId: number;
  updatedDate: string | null;
  updatedByStaffId: number | null;
}

// Request for POST tenants/{tenant_id}/commissions/adjustments (Staff Adjustment)
export interface StaffAdjustmentRequest {
  staff_id: number;
  adjutment_date: string; // ISO 8601 format
  adjustment_amount_in_minor: number; // Amount in minor units (cents)
  adjustment_notes: string;
}

export interface CreateStaffAdjustmentsRequest {
  staff_adjutments: StaffAdjustmentRequest[];
}

// Request for POST tenants/{tenant_id}/commissions/mark_as_processed
export interface CommissionTransactionToProcess {
  id: number;
  adjustment_notes: string;
}

export interface MarkCommissionsAsProcessedRequest {
  notes: string;
  transaction_ids: number[];
  payroll_transaction_id:string;
}

// Query parameters for GET endpoint
export interface GetProcessedCommissionTransactionsParams {
  companyId?: number;
  tenantIds?: number[];
  dateFrom?: string;
  dateTo?: string;
  staffIds?: number[];
  planIds?: number[];
  transactionStatus?: string;
  pageNumber?: number;
  pageSize?: number;
}

